import React from "react";


// Komponen untuk menampilkan tabel
const StuntingDesc = ({ data }) => {
  return (
    <div style={{ backgroundColor: "#f0f0f0", padding: "10px", borderRadius: "5px", lineHeight: "1.5" }}>
      <p>Stunting terbanyak ditemukan di Wilayah *NUSA TENGGARA TIMUR , Khususnya di Kecamatan *LOURA untuk kelurahan *TOTOK </p>
      <p>dengan total stunting 271 Keluarga Dari data yang disediakan </p>
      <p>- **Balita (Bayi di bawah Lima tahun): ** 101 Orang</p>
    </div>
  );
};

export default StuntingDesc;
